import React, { useState } from "react";
import { Wrapper } from "./ForgetPassword.styled";
import {
  Input,
  Button,
  Form,
  SuccessNotification,
  ErrorNotification,
} from "components/common";
import { callPostApi } from "utils/api";
import { useHistory } from "react-router";

const ForgetPassword = () => {
  const [isloading, setIsLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = (values) => {

    setIsLoading(true);
    form.resetFields();
    callPostApi("forgetPassword", {
      ...values,
      email: values?.email.toLowerCase(),
    }, () => {
      setIsLoading(false);
      SuccessNotification("Reset password link has been sent.");
    }, (err) => {
      console.log(err);
    });
  };
  
  return (
    <Wrapper>
      <div className="form-container">
        <div className="heading-conatiner">
          <h1>RESEST YOUR PASSWORD</h1>
        </div>
        <div className="form-details-conatiner">
          <Form
            name="basic"
            autoComplete="off"
            onFinish={onFinish}
            initialValues={{ remember: true }}
            form={form}
          >
            <Form.Item
              name="email"
              rules={[{ required: true, message: "Please input your email!" }]}
            >
              <div className="email-container">
                <Input autoFocus type="email" placeholder="Enter Your Email" />
              </div>
            </Form.Item>
            <Form.Item>
              <Button title="SUBMIT" loading={isloading} htmlType="submit" />
            </Form.Item>
          </Form>
        </div>
      </div>
    </Wrapper>
  );
};

export default ForgetPassword;
